import React from 'react';
import { Flex, css, Link, Box, Container, Heading } from 'theme-ui';
import ContentImages from '@solid-ui-components/ContentImages';
import ContentButtons from '@solid-ui-components/ContentButtons';
import WithDefaultContent from '@solid-ui-blocks/WithDefaultContent';
import Icon from '@solid-ui-components/ContentIcon/ContentIcon';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { styles } from './styles';
import ContentText from '@solid-ui-components/ContentText';
import Reveal from '@solid-ui-components/Reveal/Reveal';

const {
  blockHeading,
  container,
  imagesWrapper,
  appItem,
  buttonsWrapperStyles,
  header,
  heading,
  storeButtonsWrapper,
  textStyles,
  textItem,
  textItemContainer,
} = styles;

const Apps = ({ content: { collection, text } }) => (
  <Container sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} >
    {text && <ContentText sx={{ textAlign: 'center' }} content={text} />}
    <Flex sx={container}>
      {collection.slice(0, 2).map((item, index) => (
        <Flex key={`col-${index}`} sx={{ ...appItem, flexDirection: 'column' }}>
          <Flex sx={header}>
            <p css={css(heading)}>{item.text[0].text}</p>
            <Icon content={item.icon} size="s" />
          </Flex>

          <Flex sx={{ ...textItemContainer, flex: 1 }}>
            <Reveal effect={"fadeInUp"}>
              {item.text.slice(1).map((t, index) => (
                <Flex key={`text-${index}`} sx={textItem}>
                  {collection[2]?.icon && (
                    <Icon
                      content={collection[2].icon}
                      size="xxs"
                      mt={["4px", "2px", "2px", "4px", "4px", "4px"]}
                    />
                  )}
                  <p css={css(textStyles)}>{t.text}</p>
                </Flex>
              ))}
            </Reveal>
          </Flex>

          <Flex sx={{ flexDirection: 'column', alignItems: 'center', mt: 'auto' }}>
            <div css={css(imagesWrapper)}>
              <ContentImages content={{ images: item.images.slice(0, 1) }} />
            </div>

            {item.buttons ? (
              <ContentButtons wrapperStyles={buttonsWrapperStyles} content={item.buttons} />
            ) : (
              <Flex sx={{ ...storeButtonsWrapper, justifyContent: 'center' }}>
                {item.images.slice(1).map(({ alt, src, link, target }) => {
                  const imageData = getImage(src);
                  if (imageData) {
                    return (
                      <Link target="_blank" href={link.link} key={alt}>
                        <GatsbyImage image={imageData} alt={alt} />
                      </Link>
                    );
                  }
                })}
              </Flex>
            )}
          </Flex>
        </Flex>

      ))}
    </Flex>
  </Container>
);

export default WithDefaultContent(Apps);
